import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/elarsaks/Desktop/Front-end-portfolio/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Menu } from './components/Menu.tsx';
import { Home, Info, SettingsApplications, Collections, ContactMail } from '@material-ui/icons';
import t from 'prop-types';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "info"
    }}>{`Info`}</h2>
    <p>{`I needed a way to show off my skills on the front end side.`}<br parentName="p"></br>{`
`}{`So I built a reusable menu component that looks a bit more exotic.  `}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Menu} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'() => {\n  // Material-UI icons are imported on a top level, before assigning them to the props.\n  //import { Home, Info, SettingsApplications, Collections, ContactMail } from \'@material-ui/icons\'\n  const items = [\n    {\n      name: \'Home\',\n      route: \'/home\',\n      icon: Home,\n    },\n    {\n      name: \'Services\',\n      route: \'/services\',\n      icon: SettingsApplications,\n    },\n    {\n      name: \'Projects\',\n      route: \'/projects\',\n      icon: Collections,\n    },\n    {\n      name: \'About\',\n      route: \'/about\',\n      icon: Info,\n    },\n    {\n      name: \'Contact\',\n      route: \'/contact\',\n      icon: ContactMail,\n    },\n  ]\n  const [route, setRoute] = React.useState(\'Hover or Click on MENU.\')\n  return (\n    <>\n      <div\n        style={{\n          height: \'300px\',\n          textAlign: \'center\',\n          fontSize: \'2em\',\n          color: \'teal\',\n        }}\n      >\n        \"{route}\"\n      </div>\n\n      <Menu items={items} handleRouting={setRoute} />\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Menu,
      Home,
      Info,
      SettingsApplications,
      Collections,
      ContactMail,
      t,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        // Material-UI icons are imported on a top level, before assigning them to the props.
        //import { Home, Info, SettingsApplications, Collections, ContactMail } from '@material-ui/icons'
        const items = [{
          name: 'Home',
          route: '/home',
          icon: Home
        }, {
          name: 'Services',
          route: '/services',
          icon: SettingsApplications
        }, {
          name: 'Projects',
          route: '/projects',
          icon: Collections
        }, {
          name: 'About',
          route: '/about',
          icon: Info
        }, {
          name: 'Contact',
          route: '/contact',
          icon: ContactMail
        }];
        const [route, setRoute] = React.useState('Hover or Click on MENU.');
        return <>
        <div style={{
            height: '300px',
            textAlign: 'center',
            fontSize: '2em',
            color: 'teal'
          }}>"{route}"</div>
        
        <Menu items={items} handleRouting={setRoute} mdxType="Menu" />
      </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      